import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, string>, string>(
  ActionSubTypes.API_RAPORURLGETIR,
  DefaultInputDataStateModel<pList, string>()
);
